import type { ReactNode } from "react";
import styles from "./Card.module.css";

interface CardProps {
  readonly children: ReactNode;
  readonly padding?: "sm" | "md" | "lg";
  readonly shadow?: boolean;
  readonly highlight?: boolean;
  readonly className?: string;
}

export function Card({
  children,
  padding = "md",
  shadow = false,
  highlight = false,
  className,
}: CardProps) {
  return (
    <div
      className={`${styles.card} ${styles[`pad-${padding}`]} ${shadow ? styles.shadow : ""} ${highlight ? styles.highlight : ""} ${className ?? ""}`}
    >
      {children}
    </div>
  );
}
